import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import { useAccount } from 'dashboard/composables/useAccount';
import { getUserPermissions } from 'dashboard/helper/permissionsHelper';
import { READ_ONLY_PERMISSION } from 'dashboard/constants/permissions';

/**
 * Composable that tells whether the current account user is a view-only
 * ("Visualizador") user. Used to hide action controls across the dashboard.
 * The backend enforces the same restriction independently.
 *
 * @returns {{ isReadOnly: import('vue').ComputedRef<boolean> }}
 */
export function useReadOnly() {
  const user = useMapGetter('getCurrentUser');
  const { accountId } = useAccount();

  const isReadOnly = computed(() =>
    getUserPermissions(user.value, accountId.value).includes(
      READ_ONLY_PERMISSION
    )
  );

  return { isReadOnly };
}
